document.addEventListener("DOMContentLoaded", () => {
  const KEYWORD_MAP = {
    fond: ['Fond', 'Back', 'Fondo', 'Fondina', 'Bodem', 'Rugdeksel', 'Rückseite'],
    mouvement: ['Mouvement', 'Movement', 'Movimiento', 'Movimento', 'Werktuig', 'Beweging', 'Uhrwerk'],
    cadran: ['Cadran', 'Dial', 'Esfera', 'Quadrante', 'Zijplaat', 'Tellerplaat', 'Zifferblatt'],
    boitier: ['Boîtier', 'Case', 'Caja', 'Cassa', 'Kast', 'Behuizing', 'Gehäuse'],
    bracelet: ['Bracelet', 'Bracelet', 'Pulsera', 'Bracciale', 'Armband', 'Armband']
  };

  const RESPONSE_INDEX = {
    fond: 0,
    mouvement: 1,
    cadran: 2,
    boitier: 3,
    bracelet: 4
  };

  const initFAQAccordions = () => {
    const faqComponents = document.querySelectorAll(".cv-component-faq");
    
    faqComponents.forEach(component => {
      const accordions = component.querySelectorAll(".accordion:not([data-listener-attached])");
      
      accordions.forEach(accordion => {
        accordion.setAttribute("data-listener-attached", "true");
        accordion.addEventListener("click", handleAccordionClick);
      });
    });
  };

  const handleAccordionClick = (event) => {
    const accordion = event.currentTarget;
    const faqItem = accordion.closest(".faq-item");
    const panel = faqItem.querySelector(".panel");
    const more = accordion.querySelector(".more");
    const less = accordion.querySelector(".less");
    const component = accordion.closest(".cv-component-faq");

    component.querySelectorAll(".panel.active").forEach(activePanel => {
      if (activePanel !== panel) {
        togglePanel(activePanel, false);
      }
    });

    const isActive = panel.classList.contains("active");
    togglePanel(panel, !isActive);

    if (isActive) {
      more.style.display = "inline-block";
      less.style.display = "none";
    } else {
      more.style.display = "none";
      less.style.display = "inline-block";
    }
  };

  const togglePanel = (panel, shouldOpen) => {
    const accordion = panel.closest(".faq-item").querySelector(".accordion");
    const more = accordion.querySelector(".more");
    const less = accordion.querySelector(".less");

    if (shouldOpen) {
      panel.classList.add("active");
      panel.style.maxHeight = panel.scrollHeight + "px";
      more.style.display = "none";
      less.style.display = "inline-block";
    } else {
      panel.classList.remove("active");
      panel.style.maxHeight = null;
      more.style.display = "inline-block";
      less.style.display = "none";
    }
  };

  const initDynamicFAQResponses = () => {
    const productInfo = document.querySelector('main > section > product-info');
    if (!productInfo) return;

    productInfo.addEventListener('change', handleVariantChange);
  };

  const handleVariantChange = (event) => {
    const selectedVariantID = Number(event.target.value);
    if (!selectedVariantID) return;

    const faqQuestions = document.querySelectorAll('.cv-faq-items .cv-faq-question');
    
    faqQuestions.forEach(question => {
      const responseContainer = question.parentNode.parentNode.querySelector('.panel > div.tw-text-grey');
      if (!responseContainer) return;

      for (const [key, keywords] of Object.entries(KEYWORD_MAP)) {
        const hasKeyword = keywords.some(word => question.textContent.includes(word));
        
        if (hasKeyword) {
          const responseIndex = RESPONSE_INDEX[key];
          const variantResponse = window.variantResponses?.[responseIndex]?.[selectedVariantID];
          
          if (variantResponse && variantResponse !== 'null') {
            responseContainer.innerHTML = variantResponse;
          }
          break;
        }
      }
    });
  };

  initFAQAccordions();
  initDynamicFAQResponses();
});
